import * as _ from "underscore";
import { MemberTagConstant } from "../constants/member-tag.constant";

declare let $: any;

export default class AppShareHelper {
  public static isSuccessResponse(response) {
    return response["Success"];
  }

  public static translationButtonText(comment, key = "originalComment") {
    const language = navigator.language.toLowerCase();
    const buttonTexts = {
      vi: comment[key] ? "Xem bản gốc" : "Xem bản dịch",
      no: comment[key] ? "Se original" : "Se oversettelse",
      nn: comment[key] ? "Se original" : "Se oversettelse",
      sv: comment[key] ? "Se original" : "Se översättning",
      en: comment[key] ? "See original" : "See translation",
      fr: comment[key] ? "See original" : "See translation",
      de: comment[key] ? "Siehe Original" : "Siehe Übersetzung",
    };

    return buttonTexts[language] || buttonTexts["en"];
  }

  public static deepClone(data) {
    return $.extend({}, data);
  }

  public static defer(): {
    promise: Promise<any>;
    resolve: { (any) };
    reject: { (any) };
  } {
    const deferred: any = {};
    deferred.promise = new Promise(function (resolve, reject) {
      deferred.resolve = resolve;
      deferred.reject = reject;
    });
    return deferred;
  }

  public static checkLoadedPhotos(arr1, arr2) {
    const finalArray = [];

    arr1.forEach((e1) =>
      arr2.forEach((e2) => {
        if (e1.id === e2.id) {
          finalArray.push(e1);
        }
      })
    );

    return finalArray.length;
  }

  public static resize(width, height) {
    const defaultWidth = 800;
    const ratio = width / defaultWidth;
    return Math.round(height / ratio);
  }

  public static isEmpty(data) {
    return _.isEmpty(data);
  }

  public static checkLatLngPhoto(data) {
    return (
      data.exif &&
      data.exif.lat &&
      data.exif.lng &&
      data.exif.lat !== "undefined" &&
      data.exif.lng !== "undefined" &&
      data.exif.lat !== "null" &&
      data.exif.lng !== "null" &&
      data.exif.lat !== "NaN" &&
      data.exif.lng !== "NaN"
    );
  }

  public static checkLatLngLocation(data) {
    return data.lat && data.lng;
  }

  public static convertToHttps(data, field) {
    if (data[field].includes("http:")) {
      data[field] = data[field].replace("http", "https");
    }
  }

  public static setWithExpiry(key, value, ttl) {
    const now = new Date();
    now.setDate(now.getDate() + ttl);

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime(),
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  public static getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  /**
   * checkVipMember
   * @param accessLevel
   */
  public static checkVipMember(accessLevel) {
    return [
      MemberTagConstant.MOBIL,
      MemberTagConstant.FG,
      MemberTagConstant.FOTOSKOLEN,
      MemberTagConstant.GRUNNKURS,
    ].includes(accessLevel.toLowerCase());
  }

  /**
   * checkVipMember
   * @param value
   */
  public static getViewRatingPoint(value) {
    return value / 2;
  }

  /**
   * checkVipMember
   * @param value
   */
  public static getRealRatingPoint(value) {
    return value * 2;
  }

  /**
   * @param ticketNumber
   * @param accessLevel
   */
  public static getNumberOfTicketByAccessLevel(ticketNumber, accessLevel) {
    if (accessLevel === "FG") {
      return ticketNumber * 2;
    }

    if (
      accessLevel === "FOTOSKOLEN" ||
      accessLevel === "GRUNNKURS" ||
      accessLevel === "MOBIL"
    ) {
      return ticketNumber * 3;
    }

    return ticketNumber;
  }

  public static convertViewRatingPoint(input, output) {
    [
      "general",
      "cameraSettings",
      "composition",
      "presentation",
      "vision",
      "editing",
    ].forEach((item) => {
      output[item] = AppShareHelper.getViewRatingPoint(input[item]);
    });
  }

  public static calculateImageSize(photo) {
    const containerWidth = $(".container").width();

    let width = 350;
    if (containerWidth <= 330) {
      width = 330;
    } else if (330 < containerWidth && containerWidth <= 345) {
      width = 338;
    } else if (345 < containerWidth && containerWidth <= 375) {
      width = 360;
    } else if (375 < containerWidth && containerWidth <= 390) {
      width = 379;
    } else if (390 < containerWidth && containerWidth <= 414) {
      width = 395;
    } else if (414 < containerWidth && containerWidth <= 576) {
      width = 510;
    } else if (576 < containerWidth && containerWidth <= 768) {
      width = 330;
    } else if (768 < containerWidth && containerWidth <= 992) {
      width = 283;
    }

    const ratio = (photo.width || 0) / width;

    return (photo.height || 0) / ratio;
  }

  public static calculateImageSizeForFluidContainer(photo) {
    let width = $(".img-fluid").width();
    const ratio = (photo.width || 0) / width;

    return (photo.height || 0) / ratio;
  }

  public static getDateTimeWithTimezone = (date, type, timezone = 2) => {
    if (type === "start") {
      date.setUTCHours(0, 0, 0, 0);
    } else {
      date.setUTCHours(23, 59, 59, 999);
    }

    if (timezone) {
      date.setHours(date.getHours() - timezone);
    }

    return date;
  };
}
